<script>
  import { userStore } from "../etc/store.js"
  import PrivatePage from "./PrivatePage.svelte"
  import Gua64 from "../utils/Gua64.svelte"

  let sectionName = "Play"
  let isLogin = false
  // Listen for auth status change
  $: if ($userStore.isLogin == true) {
    isLogin = true
  } else {
    isLogin = false
  }
</script>

<main>
  {#if isLogin}
    <h3>周易</h3>
    <Gua64 {sectionName} />
  {:else}
    <PrivatePage />
  {/if}
</main>

<!-- <Play /> -->
<style>
  /* .gua-xu-song {
    text-align: center;
    background-color: darkkhaki;
    padding-top: 10px;
    padding-bottom: 10px;
  } */
</style>
